import React from 'react';
import { QuotesLeft, QuotesRight } from 'components/svg';

function FounderMessage() {
  return (
    <div className="section">
      <div className="container" id="message">
        <div className="row mb-5">
          <div className="col-12 offset-0 col-lg-8 offset-lg-2 text-center">
            <h2>A Message From WellPay AI&apos;s Founder</h2>
          </div>
        </div>
        <div className="message-container">
          <div className="message-owner">
            <img
              alt="Cynthia, Founder of WellPay AI"
              className="avatar"
              src="/assets/img/profiles/cynthia_profile_pic.jpg"
              loading="lazy"
            />
            <div>
              <h2>Cynthia</h2>
              <h6>Founder</h6>
            </div>
          </div>
          <div className="message-detail">
            <QuotesLeft className="quotes-left" />
            <p>
              Hi There,
              <br />
              <br />
              I’m Cynthia, founder of WellPay and compensation strategy
              enthusiast. For more than 10 years, I’ve helped Fortune 500
              companies and startups alike fuel their growth with strategic
              total rewards and employee benefit offerings designed to transform
              their organization from the inside out.
              <br />
              <br />
              As a former total rewards VP, I’ve seen firsthand how the lack of
              comprehensive resources on compensation planning can drive even
              the most skilled HR teams into the ground, whether it be from
              employee burnout or non-stop team member turnover.
              <br />
              <br />
              Now, I’ve designed WellPay AI to fix that.
              <br />
              <br />
              Using the power of modern AI technologies and my own hard-earned
              industry insights, WellPay is an innovative approach to
              compensation and benefits planning that puts the power of change
              in your hands. Most importantly, our AI-powered tools and
              executive advisors make it fast and simple to create effective pay
              strategies, no stress or headaches required.
              <br />
              <br />
              If you’re ready to see the difference WellPay can make for your
              organization, I invite you to explore WellPay today.
            </p>
            <QuotesRight className="quotes-right" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FounderMessage;
